/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Status from './Status/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/ChangeStatus/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Change treatment status"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 gap={dtSpaceS}
>
{childProps => (
<Status
{...childProps}
  viewPath={`${viewPath}/Status`}
/>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
{...childProps}
  viewPath={`${viewPath}/SaveAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}